<template>
  <div
    class="support-launcher"
    :class="launcherClasses"
    :style="offsetStyle"
    data-test="support-widget-launcher"
  >
    <button
      type="button"
      class="support-launcher__open"
      aria-label="Abrir o suporte"
      data-test="btn-support-widget-launcher"
      @click="$emit('open')"
    >
      <PhHeadset
        :size="22"
        weight="fill"
      />
      <span
        v-if="hasPending"
        class="support-launcher__badge"
        data-test="support-widget-launcher-badge"
      >
        {{ badgeLabel }}
      </span>
    </button>
    <button
      type="button"
      class="support-launcher__dismiss"
      aria-label="Esconder o suporte"
      data-test="btn-support-widget-dismiss"
      @click="$emit('dismiss')"
    >
      <PhX
        :size="10"
        weight="bold"
      />
    </button>
  </div>
</template>

<script>
const MAX_BADGE = 9;
const OVER_BADGE_LABEL = `${MAX_BADGE}+`;

/**
 * A bolinha do chat de suporte no canto da tela. Aparece depois que a pessoa
 * abre o suporte pelo menu, ou quando chega resposta, e fica ate ser
 * dispensada. Quem decide QUANDO ela existe e o SupportWidgetHost.
 */
export default {
  name: 'SupportWidgetLauncher',

  props: {
    /* Conversas com resposta nao lida mais os avisos pendentes. */
    pending: { type: Number, default: 0 },
    /* O suporte deixou um aviso que pede atencao. */
    hasAttention: { type: Boolean, default: false },
    offsetStyle: { type: Object, default: null }
  },

  computed: {
    hasPending() {
      return this.pending > 0;
    },

    badgeLabel() {
      return this.pending > MAX_BADGE ? OVER_BADGE_LABEL : String(this.pending);
    },

    launcherClasses() {
      return { 'support-launcher--attention': this.hasAttention };
    }
  }
};
</script>

<style lang="scss" scoped>
.support-launcher {
  position: fixed;
  right: 24px;
  bottom: 48px;
  z-index: 6;
  zoom: calc(1 / var(--tc-zoom));
}

.support-launcher__open {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 0;
  border-radius: 50%;
  background: var(--tc-action);
  color: var(--tc-action-on);
  cursor: pointer;
  transition: transform var(--tc-transition);
}

.support-launcher__open:hover {
  transform: scale(1.06);
}

.support-launcher__open:focus-visible,
.support-launcher__dismiss:focus-visible {
  outline: 2px solid var(--tc-action);
  outline-offset: 2px;
}

.support-launcher--attention .support-launcher__open {
  outline: 2px solid var(--tc-warning-strong);
  outline-offset: 2px;
}

.support-launcher__badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: var(--tc-radius-pill);
  background: var(--tc-danger);
  color: var(--tc-action-on);
  font-size: 10px;
  font-weight: var(--tc-fw-bold);
  line-height: 18px;
  text-align: center;
}

.support-launcher--attention .support-launcher__badge {
  background: var(--tc-warning-strong);
}

.support-launcher__dismiss {
  position: absolute;
  top: -6px;
  left: -6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1px solid var(--tc-line);
  border-radius: 50%;
  background: var(--tc-surface);
  color: var(--tc-text-2);
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--tc-transition);
}

.support-launcher:hover .support-launcher__dismiss,
.support-launcher__dismiss:focus-visible {
  opacity: 1;
}

@media (hover: none) {
  .support-launcher__dismiss {
    opacity: 1;
  }
}
</style>
